import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// material UI
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { FormControlLabel, Switch } from '@material-ui/core';

import * as CONSTANTS from '../constants';
import * as UTILS from '../utils/utilFunctions';
import { createCandidateReminder } from '../reminders/api/candidateReminderAPI';

class AddCandidateReminderPopUp extends PureComponent {
  constructor(props) {
    super(props);
    const d = new Date();
    d.setDate(d.getDate() + 1);
    d.setHours(9);
    d.setMinutes(0);
    this.state = {
      inputFields: {
        dueDate: d,
        comment: '',
        sendMail: true
      }
    };
    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  addCandidateReminderAPICall = async () => {
    const requestBody = {
      candidateReminder: {
        candidate: this.props.candidateId,
        note: this.state.inputFields.comment,
        dueDate: this.state.inputFields.dueDate
      },
      notification: {
        type: 'candidateReminder',
        triggerDate: this.state.inputFields.dueDate
      },
      sendMail: this.state.inputFields.sendMail
    };

    try {
      await createCandidateReminder(requestBody);
      this.props.handleSnackbarOpen('Wiedervorlage wurde erfolgreich angelegt.');
      this.props.handleClose(true);
    } catch (err) {
      const ignoreErrorCodes = [500];
      this.errorHandling(err, CONSTANTS.createCandidateReminderURL, null, ignoreErrorCodes);
      if (err.status === 500) {
        this.props.handleSnackbarOpen('Wiedervorlage konnte nicht angelegt werden.');
      }
    }
  };

  handleSaveButtonClick = () => {
    this.addCandidateReminderAPICall();
  };

  handleCancelButtonClick = () => {
    this.props.handleClose(false);
  };

  onInputFieldChange = e => {
    const inputFieldValue = e.target.value;
    const inputFieldKey = e.target.id ? e.target.id : e.target.name;
    this.setState(prevState => ({
      inputFields: {
        ...prevState.inputFields,
        [inputFieldKey]: inputFieldValue
      }
    }));
  };

  onDueDateChange = dueDate => {
    this.setState(prevState => ({
      inputFields: {
        ...prevState.inputFields,
        dueDate
      }
    }));
  };

  onSendMailChange = () => {
    this.setState(prevState => ({
      inputFields: {
        ...prevState.inputFields,
        sendMail: !prevState.inputFields.sendMail
      }
    }));
  };

  renderInputFields() {
    return (
      <div className="row">
        <div className="col-12 mt-2 mb-1">
          <TextField fullWidth disabled id="candidateName" value={this.props.candidateName} label="Kandidat" />
        </div>
        <div className="col-12 mt-1 mb-1">
          <KeyboardDateTimePicker
            fullWidth
            label="Fälligkeitsdatum"
            onChange={this.onDueDateChange}
            value={this.state.inputFields.dueDate}
            format="dd.MM.yyyy, HH:mm"
            cancelLabel="Abbrechen"
            animateYearScrolling={false}
            ampm={false}
          />
        </div>
        <div className="col-12 mt-1 mb-1">
          <FormControlLabel
            control={
              <Switch
                onChange={this.onSendMailChange}
                value={this.state.inputFields.sendMail}
                checked={this.state.inputFields.sendMail}
                color="primary"
              />
            }
            label="Termin per Mail an mich schicken"
          />
        </div>
        <div className="col-12 mt-1 mb-1">
          <TextField
            fullWidth
            id="comment"
            multiline
            rows="4"
            rowsMax="10"
            onChange={this.onInputFieldChange}
            value={this.state.inputFields.comment}
            label="Bemerkung"
          />
        </div>
      </div>
    );
  }

  renderPopUp() {
    return (
      <Dialog open={this.props.open}>
        <DialogTitle>{`Wiedervorlage ${this.props.candidateName || ''}`.trim()}</DialogTitle>
        <DialogContent>
          <div className="container">{this.renderInputFields()}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancelButtonClick} color="primary">
            Abbrechen
          </Button>
          <Button onClick={this.handleSaveButtonClick} color="primary">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    return <div>{this.renderPopUp()}</div>;
  }
}

AddCandidateReminderPopUp.defaultProps = {
  candidateName: ''
};
AddCandidateReminderPopUp.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSnackbarOpen: PropTypes.func.isRequired,
  candidateId: PropTypes.string.isRequired,
  candidateName: PropTypes.string
};
export default AddCandidateReminderPopUp;
